<template>
  <div :class="$style.footer">
    <nav :class="$style.footerNav">
      <UiKitTypography :type="MAP.B04D">
        {{ new Date().getFullYear() }} Ⓒ HackenProof
      </UiKitTypography>
      <a href="https://hackenproof.com/blog/" target="_blank">
        <UiKitTypography :type="MAP.B04D">Blog</UiKitTypography>
      </a>
      <a href="https://docs.hackenproof.com/" target="_blank">
        <UiKitTypography :type="MAP.B04D">Docs</UiKitTypography>
      </a>
      <a href="https://hackenproof.com/contacts" target="_blank">
        <UiKitTypography :type="MAP.B04D">Contact us</UiKitTypography>
      </a>
      <a href="https://hackenproof.com/privacy-notice" target="_blank">
        <UiKitTypography :type="MAP.B04D">Privacy Notice</UiKitTypography>
      </a>
      <a href="https://hackenproof.com/terms" target="_blank">
        <UiKitTypography :type="MAP.B04D">Terms</UiKitTypography>
      </a>
    </nav>
    <div :class="$style.footerSocials">
      <a href="https://www.youtube.com/@hackenproof" target="_blank">
        <img src="@/images/icons/youtube.svg" alt="youtube" />
      </a>
      <a href="https://discord.com/invite/NHX6yt73vh" target="_blank">
        <img src="@/images/icons/discord.svg" alt="discord" />
      </a>
      <a href="https://x.com/HackenProof" target="_blank">
        <img src="@/images/icons/twitter.svg" alt="twitter" />
      </a>
      <a href="https://www.linkedin.com/company/hackenproof/" target="_blank">
        <img src="@/images/icons/linkedin.svg" alt="linkedin" />
      </a>
    </div>
  </div>
</template>

<script setup>
import UiKitTypography from "@/ui-kit/Typography.vue";
import { MAP } from "@/constants/typography";
</script>

<style module lang="scss">
.footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 180px;
  gap: 16px;
  flex-wrap: wrap;

  @media screen and (max-width: 1920px) {
    padding: 56px 40px 16px 40px;
  }

  @media screen and (max-width: 1200px) {
    justify-content: center;
  }

  @media screen and (max-width: 990px) {
    padding: 40px 16px 16px 16px;
    flex-direction: column;
  }

  .footerNav {
    display: flex;
    align-items: center;
    gap: 24px;
    flex-shrink: 0;

    @media screen and (max-width: 990px) {
      flex-shrink: 1;
      flex-wrap: wrap;
      justify-content: center;
      order: 2;
      max-width: 400px;
      gap: 8px;

      > * {
        order: 1;
        padding: 0 8px;
      }

      > :first-child {
        order: 2;
      }
    }
  }

  .footerSocials {
    display: flex;
    gap: 16px;
    flex-shrink: 0;

    @media screen and (max-width: 990px) {
      order: 1;
    }
  }
}
</style>
